import { create } from "zustand";

export interface DashboardAgent {
  id: string;
  name: string;
  status: "draft" | "live" | "paused";
  persona: string;
  language: string;
  custom_instructions: string | null;
  voice_name: string;
  embed_enabled: boolean;
  allowed_origins: string[];
  daily_message_quota: number;
  created_at?: string;
}

interface AgentSelectionState {
  agents: DashboardAgent[];
  selectedAgentId: string | null;
  setAgents: (agents: DashboardAgent[]) => void;
  setSelectedAgentId: (id: string | null) => void;
  selectedAgent: () => DashboardAgent | null;
}

export const useAgentSelectionStore = create<AgentSelectionState>((set, get) => ({
  agents: [],
  selectedAgentId:
    typeof window === "undefined"
      ? null
      : window.localStorage.getItem("mira_selected_agent_id"),
  setAgents: (agents) =>
    set((state) => {
      const selectedStillExists = agents.some((agent) => agent.id === state.selectedAgentId);
      const selectedAgentId = selectedStillExists
        ? state.selectedAgentId
        : agents[0]?.id ?? null;
      if (selectedAgentId) {
        window.localStorage.setItem("mira_selected_agent_id", selectedAgentId);
      }
      return { agents, selectedAgentId };
    }),
  setSelectedAgentId: (id) => {
    if (id) window.localStorage.setItem("mira_selected_agent_id", id);
    else window.localStorage.removeItem("mira_selected_agent_id");
    set({ selectedAgentId: id });
  },
  selectedAgent: () => {
    const state = get();
    return state.agents.find((agent) => agent.id === state.selectedAgentId) ?? null;
  },
}));
